import { render } from "./CreateCourse.vue?vue&type=template&id=51d7d5fa&scoped=true"
import script from "./CreateCourse.vue?vue&type=script&lang=js"
export * from "./CreateCourse.vue?vue&type=script&lang=js"

import "./CreateCourse.vue?vue&type=style&index=0&id=51d7d5fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51d7d5fa"]])

export default __exports__